import { useMemo } from 'react';

export const useLpTeamLink = () => {
  const teamLink = useMemo(() => {
    if (process.env.REACT_APP_ENV === 'production') {
      return 'https://lp.sejuku.net/terakoya/biz/?cid=ss_header_to_terakoyabiz';
    } else {
      return `${process.env.REACT_APP_DOMAIN}/team/register/creation`;
    }
  }, []);

  return { teamLink };
};
